/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */

/**
 * Member role within the team.
 */
export type DashboardTeamMemberRole =
  (typeof DashboardTeamMemberRole)[keyof typeof DashboardTeamMemberRole];

export const DashboardTeamMemberRole = {
  captain: "captain",
  playingCaptain: "playingCaptain",
  coach: "coach",
  doctor: "doctor",
  player: "player",
  staff: "staff",
} as const;
